import { render, staticRenderFns } from "./Header copy 4.vue?vue&type=template&id=5899ed7e&scoped=true"
import script from "./Header copy 4.vue?vue&type=script&lang=js"
export * from "./Header copy 4.vue?vue&type=script&lang=js"
import style0 from "./Header copy 4.vue?vue&type=style&index=0&id=5899ed7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5899ed7e",
  null
  
)

export default component.exports